var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUptrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.308,
    height: 6.185,
    viewBox: "0 0 10.308 6.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trending_up_FILL0_wght400_GRAD0_opsz24",
    d: "M80.722-713.815,80-714.537l3.814-3.84,2.062,2.062,2.68-2.654h-1.34V-720h3.092v3.092H89.277v-1.34l-3.4,3.4-2.062-2.062Z",
    transform: "translate(-80 720)",
    fill: "#1a8400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptrend);
export default __webpack_public_path__ + "static/media/uptrend.d3133a8bb3a3f24b0ecc6dde0c2ee356.svg";
export { ForwardRef as ReactComponent };